import {
  IPpPlanningWizardDetailsData,
  IPpPlanningWizardOverviewGridData,
  IPpPlanningWizardSelectionGridData,
  IPpProductListGridItem,
  IPpWizardProvider,
  PpWizardStates
}                                                   from '../pp-planning-wizard.types';
import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import {
  ApDynGridColumnConfigBase
}                                                   from '../../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                   from '../../../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  ApDynformsConfigFieldset
}                                                   from '../../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  EventEmitter,
  Injectable
}                                                   from '@angular/core';
import {
  ApDynGridPagerWizardBreadcrumbsStepper,
  ApDynGridPagerWizardButton,
  ApDynGridPagerWizardConfig
}                                                   from '../../../../ap-dyngrids/config/ap-dyn-grid-pager-wizard-config';
import {
  filter,
  map
}                                                   from 'rxjs/operators';
import {
  MapViewMode
}                                                   from '../../../../ap-interface';
import {
  LanguageStore
}                                                   from '../../../../stores/translation/language.store';
import {
  SettingsStore
}                                                   from '../../../../stores/base-data/settings.store';
import {
  MapViewStore
}                                                   from '../../../../stores/layout/mapview.store';
import {
  ApGuidUtil,
  ApTimeSpanUtil
}                                                   from '../../../../ap-utils';
import {
  GetRoundNumericService
}                                                   from '../../../../ap-utils/service/get-round-numeric.service';
import {
  MachineStore
}                                                   from '../../../../stores/docu/machine.store';
import {
  InstrumentStore
}                                                   from '../../../../stores/docu/instrument.store';
import {
  DriverStore
}                                                   from '../../../../stores/docu/driver.store';
import {
  WorkTypes
}                                                   from '../../../../stores/base-data/worrktypes.store';
import {
  PpCommonService
}                                                   from '../../../../plant-protection/services/pp-common.service';
import {
  OperationModesEnum,
  OperationModesStore
}                                                   from '../../../../stores/common/operation-modes.store';
import {
  MapFactoryStyler
}                                                   from '../../../../map-factory/style';
import {
  PlantProtectionPlanBookStore
}                                                   from '../../../../stores/plant-protection/plant-protection-planbook.store';
import {
  MapStore
}                                                   from '../../../../stores/map/map.store';
import {
  ApplicationModesEnum,
  ApplModesStore
}                                                   from '../../../../stores/common/appl-modes.store';
import {
  LoginStore
}                                                   from '../../../../stores/login/login.store';
import {
  UnitsStore
}                                                   from '../../../../stores/common/units.store';
import {
  ApDateService
}                                                   from '../../../../ap-core/services/ap-date-service';
import {
  CampaignYearStore
}                                                   from '../../../../stores/login/campaignyear.store';
import {
  ObjectFactory
}                                                   from 'ts-tooling';
import {
  BestScanData,
  BestScanType
}                                                   from '../../../../types/scan.types';
import {
  NFertilizationPlantProtectionService
}                                                   from '../../../../services/data/n-fertilization-plant-protection.service';
import {
  ApDynComponentComponent
}                                                   from '../../../../ap-dyncomponent/ap-dyncomponent.component';
import {
  FieldStore
}                                                   from '../../../../stores/farm/field.store';
import {
  PlantProtectionService
}                                                   from '../../../../services/data/plant-protection.service';
import {
  ApElementType
}                                                   from '../../../../ap-interface/enums/ap-elements-type.enum';
import {
  PpPlanningBookingDataService
}                                                   from '../../../../plant-protection/services/pp-planning-booking-data.service';
import {
  OverviewGridColumnsUiProvider
}                                                   from './ui-providers/overview.grid-columns.ui-provider';
import {
  ApColumnState
}                                                   from '../../../../ap-interface/enums/ap-column-state.enum';
import {
  PpPlanningWizardStatisticService
}                                                   from '../services/pp-planning-wizard-statistic.service';
import {
  TimeAreaService
}                                                   from '../../../../services/data/time-area.service';
import {
  FieldScanData
}                                                   from '../../../../types/n-fertilization-plant-protection.types';
import IGuid = System.IGuid;
import INPlanningData = Data.NFertilization.INPlanningData;
import IPlantProtectionPlanBook = Data.TaskManagement.IPlantProtectionPlanBook;
import IPlantProtectionSummary = Data.TaskManagement.IPlantProtectionSummary;
import TaskManagementStatus = Data.TaskManagement.TaskManagementStatus;
import IPlantProtectionProductList = Data.TaskManagement.IPlantProtectionProductList;
import ScanType = Data.NDI.Enums.ScanType;

// ATTENTION: injectable 'root' is very convenient in here because we can inject all needed stores.
// BUT: This will reuse THE SAME instance of the provider every time. Therefore, we need to carefully handle the 'onDestroy' method!
@Injectable({providedIn: 'root'})
export class PpPlanningWizardOverviewProvider implements IPpWizardProvider<IPpPlanningWizardOverviewGridData, IPpPlanningWizardOverviewGridData[]> {
  private _caption$: BehaviorSubject<string>;
  private _fieldSets$: BehaviorSubject<ApDynformsConfigFieldset[]>;
  private _handleStateChange: EventEmitter<PpWizardStates>;
  private _isContinueActive: BehaviorSubject<boolean>;
  private _dynComponent: ApDynComponentComponent;
  private _items$: BehaviorSubject<IPpPlanningWizardOverviewGridData[]>;
  private _selectedGridData: IPpPlanningWizardSelectionGridData[];
  private _productListData: IPpProductListGridItem[];

  constructor(private languageStore: LanguageStore,
              private settingsStore: SettingsStore,
              private mapViewStore: MapViewStore,
              private machineStore: MachineStore,
              private instrumentStore: InstrumentStore,
              private campaignYearStore: CampaignYearStore,
              private driverStore: DriverStore,
              private mapStore: MapStore,
              private plantProtectionPlanBookStore: PlantProtectionPlanBookStore,
              private loginStore: LoginStore,
              private fieldStore: FieldStore,
              private operationModesStore: OperationModesStore,
              private applicationModesStore: ApplModesStore,
              private unitsStore: UnitsStore,
              private dateService: ApDateService,
              private ppCommonService: PpCommonService,
              private timeAreaService: TimeAreaService,
              private ppDataService: PpPlanningBookingDataService,
              private roundNumericService: GetRoundNumericService,
              private plantProtectionService: PlantProtectionService,
              private ppPlanningWizardStatisticService: PpPlanningWizardStatisticService,
              private nFertilizationPlantProtectionService: NFertilizationPlantProtectionService,
              private overviewGridColumnsUiProvider: OverviewGridColumnsUiProvider) {
  }

  /**
   * Initializes the wizard step provider
   * Sets up required observables and event handlers
   * @param caption$ Observable for the step caption
   * @param fieldSets$ Observable for form field sets
   * @param handleStateChange Event emitter for state changes
   * @param isContinueActive Observable for continue button state
   * @param dynComponent Reference to the dynamic component
   * @public
   */
  public init(caption$: BehaviorSubject<string>,
              fieldSets$: BehaviorSubject<ApDynformsConfigFieldset[]>,
              handleStateChange: EventEmitter<PpWizardStates>,
              isContinueActive: BehaviorSubject<boolean>,
              dynComponent: ApDynComponentComponent): void {
    this._caption$ = caption$;
    this._fieldSets$ = fieldSets$;
    this._handleStateChange = handleStateChange;
    this._isContinueActive = isContinueActive;
    this._dynComponent = dynComponent;
    this._items$ = new BehaviorSubject<IPpPlanningWizardOverviewGridData[]>([]);
  }

  /**
   * Determines if continue button should be active and updates observable
   * Updates the grid items with data from plant protection plan book statistics
   * Maps statistics to grid items and updates water-related values
   * Sets loading state and error messages for each grid item
   * @param selectionData Selected field data
   * @param detailsData Details configuration data
   * @param selectedProducts Products selected for application
   * @returns Observable of grid items with updated statistics
   * @public
   */
  public buildDataItems(selectionData: IPpPlanningWizardSelectionGridData[], detailsData: IPpPlanningWizardDetailsData,
                        selectedProducts: IPpProductListGridItem[]): Observable<IPpPlanningWizardOverviewGridData[]> {
    this._selectedGridData = selectionData;
    this._productListData = selectedProducts;
    // pre-fill our planBook and gridItems with the values from selection and details
    const defaultGridItems = this.generateDefaultGridItems(selectionData, detailsData, selectedProducts);
    if (this.nFertilizationPlantProtectionService.isOperationModeAnyOfMaps(detailsData.FormData.OperationModeKey)) {
      this.createPPPlanningJob(defaultGridItems);
    }
    this._items$.next(defaultGridItems);

    // ... and in case the operationMode required a statistic to be read => update our default values
    return combineLatest([
      this._items$.asObservable(),
      this.plantProtectionPlanBookStore.Listen(s => s.fieldPPPlanningStatistic)
    ]).pipe(
      map(([gridItems, ppStatistics]) => gridItems.map((gridItem) => {
          let columnLoading = this.nFertilizationPlantProtectionService.isOperationModeAnyOfMaps(
            gridItem.DetailsData?.FormData.OperationModeKey);
          let errorMessage = '';
          if (ppStatistics && ppStatistics.length > 0) {
            const statistic = ppStatistics?.filter(x => x.FieldGeomId === gridItem.SelectionData.Geom.Id) ?? [];
            if (statistic && statistic.length > 0) {
              columnLoading = false;
              if (!!statistic[0].ErrorText && statistic[0].ErrorText !== '') {
                errorMessage = statistic[0].ErrorText;
                gridItem.PlanBook.ApplicationRate = -1;
                gridItem.PlanBook.ApplicationMin = -1;
                gridItem.PlanBook.ApplicationMax = -1;
              } else {
                gridItem.PlanBook.ApplicationRate = this.roundNumericService.roundAsNumber(statistic[0].Mean, 0);
                gridItem.PlanBook.ApplicationMin = this.roundNumericService.roundAsNumber(statistic[0].Min, 0);
                gridItem.PlanBook.ApplicationMax = this.roundNumericService.roundAsNumber(statistic[0].Max, 0);
                // Update planBook's productList to have individual productRate per field
                gridItem.PlanBook.ProductList.forEach(productListItem => {
                  const selectedProduct = gridItem.SelectedProducts.FirstOrDefault(x => x.ProductListItem.Product.Id === productListItem.Product.Id);
                  const productRate = gridItem.PlanBook.ApplicationRate * selectedProduct.ProductListItem.ProductRate / gridItem.DetailsData.FormData.WaterAvg;
                  productListItem.ProductRate = this.roundNumericService.roundAsNumber(productRate);
                });
                gridItem.PlanBook.JobInput = JSON.stringify(gridItem.SelectionData.ScanData);
                gridItem.Products = this.ppCommonService.getAppliedProductsExpr(gridItem.PlanBook.ProductList);
                gridItem.ProductsTooltip = this.ppCommonService.getAppliedProductsExpr(gridItem.PlanBook.ProductList, true);
              }
            }
          }
          gridItem.ColumnLoading = columnLoading;
          gridItem.ErrorMessage = errorMessage;
          gridItem.HasError = errorMessage !== '';
          return gridItem;
        })
      )
    );
  }

  /**
   * Creates and configures grid columns based on the operation mode
   * Combines language and settings data to build appropriate columns
   * @param detailsData Details configuration data containing operation mode
   * @returns Observable of grid column configurations
   * @public
   */
  public getGridColumnConfig(detailsData: IPpPlanningWizardDetailsData): Observable<ApDynGridColumnConfigBase[]> {
    return combineLatest([
      this.languageStore.SelectedLanguage$,
      this.settingsStore.FirstSetting$
    ]).pipe(
      filter(([language, setting]) => !!language && !!setting),
      map(([language, _]) => {
        const mapHide = this.mapViewStore.Listen(s => s.mode).pipe(
          map((mapMode) => mapMode === MapViewMode.HIDE));
        const overviewColumns: ApDynGridColumnConfigBase[] = this.overviewGridColumnsUiProvider.getCommonColumns(mapHide);
        switch (detailsData.FormData.OperationModeKey) {
          case OperationModesEnum.Constant:
            if (detailsData.FormData.WorkType === WorkTypes.Spraying) {
              overviewColumns.Add(this.overviewGridColumnsUiProvider.getUniformSprayingColumns());
            }
            break;
          case OperationModesEnum.PpTarget:
          case OperationModesEnum.PpTargetMapPerField:
          case OperationModesEnum.PPTargetMapPerPlan:
            overviewColumns.AddRange(this.overviewGridColumnsUiProvider.getTargetRateColumns());
            break;
        }
        overviewColumns.AddRange(this.overviewGridColumnsUiProvider.getCommonEndColumns(language));
        return overviewColumns;
      })
    );
  }

  /**
   * Creates grid pager configuration for the overview wizard step
   * Sets up back button, breadcrumb stepper, and save button
   * @param breadCrumbsColumns Array of wizard states for breadcrumb navigation
   * @returns Configured grid pager for the wizard
   * @public
   */
  public getPagerConfig(breadCrumbsColumns: PpWizardStates[]): ApDynGridPagerConfigBase {
    return new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardButton('Global_Back_With_Arrow', this._handleStateChange, {value: PpWizardStates.Details}),
      new ApDynGridPagerWizardBreadcrumbsStepper(
        breadCrumbsColumns, 2),
      new ApDynGridPagerWizardButton('Global__Save', this._handleStateChange,
        {active: this._isContinueActive, value: PpWizardStates.Save, primary: true}));
  }

  /**
   * Handles grid selection changes and updates selected fields
   * Updates the field store with selected field IDs
   * Shows selected plan books in the map
   * @param selectedItems Currently selected grid items
   * @public
   */
  public onGridSelectionChanged(selectedItems: IPpPlanningWizardOverviewGridData[]): void {
    let selectedFieldIds: string[];
    let selectedPlanbooks: IPlantProtectionPlanBook[];
    if (selectedItems?.length > 0) {
      selectedFieldIds = selectedItems.map(x => x.SelectionData.Id.toString());
      selectedPlanbooks = selectedItems.filter(x => !x.ColumnLoading).map(x => x.PlanBook);
    } else {
      const allItems = this._dynComponent.items as IPpPlanningWizardOverviewGridData[];
      selectedFieldIds = allItems.map(x => x.SelectionData.Id.toString());
      selectedPlanbooks = allItems.filter(x => !x.ColumnLoading).map(x => x.PlanBook);
    }
    this.fieldStore.changeSelectedField(selectedFieldIds);
    this.ppDataService.showPlanBooksInMap(selectedPlanbooks);
  }

  /**
   * Generates overview statistics for the current wizard step
   * Uses the current selection, details, and product data to create statistics
   * @public
   */
  public onGenerateStatistic(): void {
    if (!this._selectedGridData || !this._productListData) {
      return;
    }
    this.ppPlanningWizardStatisticService.generateOverviewStats(
      this._items$.getValue() as IPpPlanningWizardOverviewGridData[],
      this._selectedGridData,
      this._productListData
    );
  }

  /**
   * Updates the caption text for the current wizard step
   * Sets the caption to 'Admin_Pages__Overview'
   * @public
   */
  public updateCaption(): void {
    this._caption$.next('Admin_Pages__Overview');
  }

  /**
   * Clears field sets for the overview step
   * Sets field sets observable to an empty array
   * @public
   */
  public updateFieldSets(): void {
    this._fieldSets$.next([]);
  }

  /**
   * Performs cleanup when leaving the overview wizard step
   * Clears raster statistic data and returns a copy of current grid items
   * @returns Array of current overview grid items
   * @public
   */
  public onLeave(): IPpPlanningWizardOverviewGridData[] {
    this._selectedGridData = undefined;
    this._productListData = undefined;
    this.plantProtectionPlanBookStore.clearPPPlanningStatistic();
    return ObjectFactory.Copy(this._items$.getValue());
  }

  /**
   * Cleans up provider resources when the component is destroyed
   * Currently empty, but can be extended for additional cleanup
   * @public
   */
  public onDestroy(): void {
  }

  /**
   * Creates grid items for the overview step from selected data
   * Calculates weighted averages, control factors, and sets up operation modes
   * Prepares plan books for each selected field
   * @param selectionData Selected field data
   * @param detailsData Details configuration data
   * @param selectedProducts Products selected for application
   * @returns Array of grid items for the overview step
   * @private
   */
  private generateDefaultGridItems(selectionData: IPpPlanningWizardSelectionGridData[],
                                   detailsData: IPpPlanningWizardDetailsData,
                                   selectedProducts: IPpProductListGridItem[]): IPpPlanningWizardOverviewGridData[] {
    const getPlanBooks = this.getPlanBooksForSaving(detailsData, selectionData,
      selectedProducts?.map(p => p.ProductListItem));
    return selectionData.map(selectionItem => {
      const nUptakeAverage = this.getNUptakeAverageForJob(detailsData, selectionItem);
      const slopeForCalculations = this.plantProtectionService.getSlopeForCalculation(
        detailsData.ControlFactor, detailsData.FormData.WaterAvg, nUptakeAverage);
      const planBook = getPlanBooks.find(p => p.FieldGeomId === selectionItem?.Geom?.Id);
      if (slopeForCalculations === 0) {
        planBook.ApplicationMode = this.applicationModesStore.ApplicationModes.find(o => o.Key === ApplicationModesEnum.Constant);
        planBook.OperationMode = this.operationModesStore.OperationModes.find(o => o.Key === OperationModesEnum.Constant);
      }
      return {
        Id: selectionItem.Id,
        Status: this.nFertilizationPlantProtectionService.getStatusForItemOnOverviewStep(planBook.OperationMode.Key as OperationModesEnum),
        SelectionData: selectionItem,
        DetailsData: detailsData,
        SelectedProducts: selectedProducts,
        PlanBook: planBook,
        HaPerHour: detailsData.FormData.HaPerHour,
        DurationInMilliseconds: planBook.Duration?.TotalMilliseconds,
        Machine: this.machineStore.getMachineById(detailsData.FormData.Machine)?.NameWithSign,
        Instrument: this.instrumentStore.getInstrumentById(detailsData.FormData.Instrument)?.Name,
        Driver: this.driverStore.getDriverById(detailsData.FormData.Driver)?.FirstNameFullName,
        Products: this.ppCommonService.getAppliedProductsExpr(selectedProducts?.map(p => p.ProductListItem)),
        ProductsTooltip: this.ppCommonService.getAppliedProductsExpr(selectedProducts?.map(p => p.ProductListItem), true),
        SlopeForJob: slopeForCalculations,
        NUptakeAverageForJob: nUptakeAverage,
        ColumnLoading: this.nFertilizationPlantProtectionService.isOperationModeAnyOfMaps(detailsData.FormData.OperationModeKey),
        ErrorMessage: '',
        HasError: false
      } as IPpPlanningWizardOverviewGridData;
    });
  }

  /**
   * Prepares plan books for saving based on wizard details
   * @param detailsData Wizard details data
   * @param selectionData Selected field data
   * @param productList Selected product list
   * @returns Array of plant protection plan books
   * @private
   */
  private getPlanBooksForSaving(detailsData: IPpPlanningWizardDetailsData, selectionData: IPpPlanningWizardSelectionGridData[],
                                productList: IPlantProtectionProductList[]): IPlantProtectionPlanBook[] {
    const additionalValues = {
      ZeroRate: detailsData.FormData.WaterSetZeroAtMin === true
    };
    if (this.nFertilizationPlantProtectionService.isOperationModeAnyOfMaps(detailsData.FormData.OperationModeKey)) {
      if (detailsData.FormData.WaterSetZeroAtMin) {
        if (Number.isFinite(detailsData.ControlFactor)) {
          const selectedItem = selectionData.find(x => x.ScanData.Status.state === ApColumnState.Green);
          detailsData.FormData.Threshold = Math.round(selectedItem.ScanData.NUptakeAvg + (detailsData.FormData.WaterAvg - detailsData.FormData.WaterMin) / detailsData.ControlFactor);
          if (detailsData.FormData.Threshold < 0) {
            detailsData.FormData.Threshold = 0;
          }
        }
      } else {
        detailsData.FormData.Threshold = 0;
      }
    }
    const applicationModeEnum = this.nFertilizationPlantProtectionService.getApplicationModeFromOperationMode(
      detailsData.FormData.OperationModeKey);
    const applicationMode = this.applicationModesStore.Listen(a => a.data).getValue()
      .Find(a => a.Key === applicationModeEnum);
    const summary = {
      ApplicationDate: this.dateService.getDateNoon(detailsData.FormData.ApplicationDate),
      AdditionalValue: additionalValues,
      ApplicationMode: applicationMode,
      EcValue: detailsData.FormData.ECStage,
      OperationMode: this.operationModesStore.OperationModes.find(o => o.Key === detailsData.FormData.OperationModeKey),
      Slope: detailsData.ControlFactor,
      Title: detailsData.FormData.Note,
      Unit: this.unitsStore.Listen(u => u.data).value.FirstOrDefault(u => u.Key === 'Global__Unit_l_ha'),
      UserApplicationConstant: detailsData.FormData.WaterAvg,
      UserApplicationMaximum: detailsData.FormData.OperationModeKey === OperationModesEnum.Constant
        ? detailsData.FormData.WaterAvg : detailsData.FormData.WaterMax,
      UserApplicationMinimum: detailsData.FormData.OperationModeKey === OperationModesEnum.Constant
        ? detailsData.FormData.WaterAvg : detailsData.FormData.WaterMin,
      UserApplicationRate: detailsData.FormData.WaterAvg,
      FarmId: this.loginStore.SelectedFarmId
    } as IPlantProtectionSummary;
    return selectionData.map((selectionItem) => {
      const fieldScanData = {
        FieldStatus: selectionItem.Status.state,
        ScanData: selectionItem.ScanData
      } as FieldScanData;
      const operationModeForPlanEnum = this.nFertilizationPlantProtectionService.getOperationModeForPlan(
        detailsData.FormData.OperationModeKey, fieldScanData, detailsData.OperationModeAppSetting?.ApplicationSetting);
      const applicationModeForPlanEnum = this.nFertilizationPlantProtectionService.getApplicationModeForPlan(
        detailsData.FormData.OperationModeKey, applicationMode.Key as ApplicationModesEnum, fieldScanData);
      const operationModeForPlan = this.operationModesStore.getIOperationModeByKey(operationModeForPlanEnum);
      const applicationModeForPlan = this.applicationModesStore.Listen(a => a.data).getValue()
        .Find(a => a.Key === applicationModeForPlanEnum);
      const duration = this.timeAreaService.getTotalDurationInMilliseconds(selectionItem?.Geom?.AreaHa,
        detailsData.FormData.HaPerHour);
      return {
        Id: ApGuidUtil.generateNewGuid(),
        AdditionalValues: additionalValues,
        ApplicationConst: summary.UserApplicationConstant,
        ApplicationDate: summary.ApplicationDate,
        ApplicationMax: summary.UserApplicationMaximum,
        ApplicationMin: summary.UserApplicationMinimum,
        ApplicationMode: applicationModeForPlan,
        ApplicationRate: summary.UserApplicationRate,
        CampaignYear: this.campaignYearStore.getSelectedCampaignYear()?.Year,
        EcValue: summary.EcValue,
        Element: ApElementType.N, // nitrogen
        ExportDriver: detailsData.FormData.Driver,
        ExportInstrument: detailsData.FormData.Instrument,
        ExportMachine: detailsData.FormData.Machine,
        FarmId: summary.FarmId,
        FieldGeomId: selectionItem?.Geom?.Id,
        FieldId: selectionItem?.Id,
        Geom: selectionItem?.Geom?.Geom,
        FarmCropId: selectionItem?.FarmCropId,
        OperationMode: operationModeForPlan,
        ProductList: ObjectFactory.Copy(productList),
        FarmCropSecondId: selectionItem?.FarmSecondCropId,
        Slope: detailsData.ControlFactor,
        Status: TaskManagementStatus.Green,
        Summary: summary,
        Unit: summary.Unit,
        Threshold: detailsData.FormData.Threshold,
        Factor: 1,
        LogfileArea: 0,
        Area: 0,
        AreaHa: 0,
        Start: ApTimeSpanUtil.getEmptyTimeSpan(),
        Duration: ApTimeSpanUtil.getTimeSpanFromMilliseconds(duration),
        RasterId: ApGuidUtil.getEmptyGuid(),
        Note: '',
        RasterStatistics: [],
        JobInput: null,
        Statistic: null,
        ValidFrom: null,
        ValidTo: null,
        BookedBy: null,
        BookedAt: null,
        DeletedAt: null,
        CreatedAt: null,
        UpdatedAt: null,
        DeletedBy: null,
        UpdatedBy: null,
        ExportedAt: null,
        ExportedBy: null,
        ExportFormat: null,
        ExportTarget: null,
        CreatedBy: null,
        ChangedAt: null,
        ChangedBy: null,
        Version: 0,
        LogfileOperationMode: null,
        LogfileApplicationMode: null,
        Details: [],
      } as IPlantProtectionPlanBook;
    });
  }

  /**
   * Determines the N-uptake average value to use for job creation
   * Returns the overall N-uptake average for a target map per plan mode,
   * otherwise returns the scan data's N-uptake average
   * @param detailsData Details configuration containing operation mode
   * @param selectionData Selected field data containing scan information
   * @returns N-uptake average value or undefined
   * @private
   */
  private getNUptakeAverageForJob(detailsData: IPpPlanningWizardDetailsData,
                                  selectionData: IPpPlanningWizardSelectionGridData): number | undefined {
    // If a field does not have scan data, it means it cannot use n-uptake values.
    if (!selectionData?.ScanData) {
      return undefined;
    }
    if (detailsData.FormData.OperationModeKey === OperationModesEnum.PPTargetMapPerPlan) {
      return detailsData.FormData.NUptakeAverage;
    }
    return selectionData.ScanData.NUptakeAvg;
  }

  /**
   * Creates planning jobs for all grid items
   * Clears existing map data and creates new raster jobs
   * @param gridItems Overview grid items to create jobs for
   * @private
   */
  private createPPPlanningJob(gridItems: IPpPlanningWizardOverviewGridData[]): void {
    this.clearMap();
    gridItems.forEach((item: IPpPlanningWizardOverviewGridData) => {
      this._createPPPlanningRasterJob(
        item.PlanBook.Id,
        item.SelectionData?.ScanData,
        item.PlanBook.FieldGeomId,
        item.PlanBook.ApplicationMode.Id,
        item.NUptakeAverageForJob,
        item.DetailsData.FormData.WaterSetZeroAtMin ? 0 : item.PlanBook.ApplicationMin,
        item.PlanBook.ApplicationMax,
        item.PlanBook.Threshold,
        item.SlopeForJob,
        item.PlanBook.ApplicationRate,
        item.PlanBook.ApplicationConst,
        0
      );
    });
  }

  /**
   * Creates a single plant protection planning raster job
   * @param planId Unique identifier for the plan
   * @param bestScan Best scan data
   * @param fieldGeomId Field geometry identifier
   * @param applicationModeId Application mode identifier
   * @param nUptake Nitrogen uptake value
   * @param minimum Minimum application rate
   * @param maximum Maximum application rate
   * @param threshold Threshold value
   * @param slope Slope factor
   * @param applRate Appl rate
   * @param constant Constant application rate
   * @param deadBioMass Dead biomass value
   * @private
   */
  private _createPPPlanningRasterJob(planId: IGuid, bestScan: BestScanData | undefined, fieldGeomId: IGuid,
                                     applicationModeId: number, nUptake: number | undefined, minimum: number,
                                     maximum: number, threshold: number, slope: number, applRate: number,
                                     constant: number, deadBioMass: number): void {
    const nFertPlanId = bestScan?.ScanType === BestScanType.NFertilizationSensor
      ? bestScan.PlanId : ApGuidUtil.getEmptyGuid();
    const ppPlanId = bestScan?.ScanType === BestScanType.PlantProtectionSensor
      ? bestScan.PlanId : ApGuidUtil.getEmptyGuid();
    const satelliteId = bestScan?.ScanType === BestScanType.SatelliteScan
      ? bestScan.SatId : ApGuidUtil.getEmptyGuid();
    const satelliteScanType = bestScan?.ScanType === BestScanType.SatelliteScan && bestScan?.SatelliteScan === ScanType.Autumn
      ? ScanType.Autumn : ScanType.Regular;
    const planningData: INPlanningData = {
      PlanId: planId,
      NdPlanId: nFertPlanId,
      PpPlanId: ppPlanId,
      SatId: satelliteId,
      AutumnScan: satelliteScanType,
      NUptake: nUptake ?? null,
      FieldGeomId: fieldGeomId,
      ApplicationMode: applicationModeId,
      Minimum: minimum,
      Maximum: maximum,
      Constant: constant,
      Slope: slope,
      DeadBioMass: deadBioMass,
      Threshold: threshold,
      ApplRate: applRate
    };
    this.plantProtectionPlanBookStore.CreatePPPlanningRasterJob(planningData);
  }

  /**
   * Clears map-related data and layers
   * Removes legends and clears style cache
   * @private
   */
  private clearMap(): void {
    this.plantProtectionPlanBookStore.clearPPPlanningStatistic();
    MapFactoryStyler.Instance.clearStyleCache();
    this.mapStore.Layers.Clear();
    this.mapStore.Legends.removeLegend(this.mapStore.Legends.NPlanningLegend);
    this.mapStore.Legends.removeLegend(this.mapStore.Legends.PpApplicationLegend);
  }
}
